export default __webpack_public_path__ + "static/media/f1.4e5b85dd.svg";